import { IndexableType } from 'dexie'
import { NowIndexDbService } from './nowIndexDb.service'
import { DatabaseUtilityService } from './databaseUtility.service'

export type clientData = Array<IClientDataDoc>

export interface IClientDataDocBase {
  id: string
  contentType: string
  contentDataType: string
  createDateTime: string
}

export interface IClientDataDoc extends IClientDataDocBase {
  entity: any
}

export interface IClientDataDocTyped<T> extends IClientDataDoc {
  entity: T[]
}

export class ClientDataService {
  private db: NowIndexDbService
  private tableName: string

  constructor(database: string) {
    this.db = DatabaseUtilityService.getIndexDbServiceInstance(database)
    this.tableName = this.db.clientData.name
  }

  async getAllDoc(): Promise<clientData> {
    return await this.db.getAll(this.tableName)
  }

  async removeDoc(id: string): Promise<void> {
    return await this.db.remove(id, this.tableName)
  }

  async getDocument(id: string): Promise<IClientDataDoc | undefined | null> {
    return await this.db.get(id, this.tableName)
  }

  async createDocument(document: IClientDataDoc): Promise<IndexableType> {
    return this.db.addWithKey(document, this.tableName, document.id)
  }

  async updateDocument(document: IClientDataDoc): Promise<IndexableType> {
    return this.db.update(document.id, document, this.tableName)
  }

  async createOrUpdateDocument(document: IClientDataDoc) {
    return this.db.createOrUpdate(document.id, document, this.tableName)
  }

  async addDocs(documents: any) {
    return this.db.clientData.bulkAdd(documents)
  }

  async isEmpty() {
    return this.db.isEmpty(this.tableName)
  }
}
